import { GET_MERCHANTS } from 'src/graphql/queries/merchants.query';

export const getMerchantsMockResponse = {
    data: {
        merchants: {
            data: [
                {
                    id: 1,
                    mid: '1',
                    tradingName: 'Merchant Trading Name',
                    merchantAccountNumber: '00001',
                    topLevelPartner: {
                        id: 1,
                    },
                    partnerName: 'Merchant Partner Name',
                    status: 'ACTIVE',
                    dateAdded: new Date().toString(),
                    merchantContactName: 'Last First',
                    registeredAddress: {
                        county: 'County',
                        country: 'Country',
                        eircode: 'EIRCODE',
                        townOrCity: 'City',
                        addressLine1: 'AddressLine1',
                        addressLine2: 'AddressLine2',
                    },
                    contactNumber: '0121231233',
                    email: 'merchant@email.com',
                },
            ],
        },
    },
    total: 1,
};
export const getMerchantsMockApollo = {
    request: {
        query: GET_MERCHANTS,
        variables: {},
    },
    result: getMerchantsMockResponse,
};
